const GET_AZURE_METRICS_FAILED = "GET_AZURE_METRICS_FAILED";
const GET_AZURE_METRICS_FAILED_SUCCESS = "GET_AZURE_METRICS_FAILED_SUCCESS";
const GET_AZURE_METRICS_FAILED_ERROR = "GET_AZURE_METRICS_FAILED_ERROR";

export {
  GET_AZURE_METRICS_FAILED,
  GET_AZURE_METRICS_FAILED_SUCCESS,
  GET_AZURE_METRICS_FAILED_ERROR,
};
